export enum HttpStatusCode {
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401
}

export const ACCOUNT_IS_NOT_REGISTERED = 'account_is_not_registered';

export const BALANCE_OVER_LIMIT = 'balance_over_limit';

export const EMAIL_ALREADY_EXIST = 'email_already_exist';

export const ENTITY_NOT_FOUND = 'entity_not_found';

export const INVALID_AMOUNT = 'invalid_amount';
export const INVOICE_CREATED_OVER_LIMIT = 'invoice_created_over_limit';
export const INVALID_GRANT = 'invalid_grant';
export const INVALID_REQUEST = 'invalid_request';
export const INVOICE_OPERATION_ERROR = 'invoice_operation_error';

export const MONEY_IN_PER_MONTH_OVER_LIMIT = 'money_in_per_month_over_limit';

export const OTP_EXPIRED = 'otp_expired';
export const OTP_MAX_RESEND_REACHED = 'otp_max_resend_reached';
export const OTP_MAX_WRONG_REACHED = 'otp_max_wrong_reached';
export const OTP_MISMATCH = 'otp_mismatch';
export const OTP_SENT_FAILED = 'otp_sent_failed';

export const PASSWORD_MISMATCH = 'password_mismatch';

export const PHONE_ALREADY_SET = 'phone_already_set';
export const PHONE_ALREADY_EXIST = 'phone_already_exist';

export const SEND_EMAIL_FAILED = 'send_email_failed';
export const SIZE_LIMIT_EXCEEDED = 'size_limit_exceeded';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/error.ts